function quoteSlider() {
  var quoteSlider = $(".js-quote-slider");
  quoteSlider.slick({
    dots: true,
    arrows: false,
    slidesToShow: 1,
    focusOnSelect: true,
    fade: true,
  });

  // Custom arrows
  $('.js-quote-slider__buttons .prev').click(function(e){ 
    e.preventDefault(); 
		$(this).parent().parent().find(quoteSlider).slick('slickPrev');
	} );
	
	$('.js-quote-slider__buttons .next').click(function(e){
		e.preventDefault(); 
		$(this).parent().parent().find(quoteSlider).slick('slickNext');
	} );

  // Function to add zero before numbers below 10
  var helpers = {
    addZeros: function (n) {
      return (n < 10) ? '0' + n : '' + n;
    }
  };
  
  // Set current slide number in counter
  quoteSlider.on('afterChange', function(event, slick, currentSlide){
    quoteSlider.parent().parent().parent().find('.counter .current').html(helpers.addZeros(currentSlide + 1));
  });
}


export default quoteSlider;
